/**
 * @desc 获取所有成品sku编号及中文名
 */
const URL = "/rantion-basics";
import http, { updateResponse } from "@/http";
export type Response = defs.basics.ResponseDto<Array<defs.basics.PlmSkuSimpleResponseRpcDto>>;
export function request(options?: any): Promise<Response> {
  return updateResponse(
    http(URL + `/rpc/sku/getAllSkuSimple`, {
      method: "GET",

      ...options,
    }),
  );
}
